import Request from 'redux/config/services/Request'

export const processReceipt = async (
  downloadUrl: string,
  contentType: string
) => {
  const response = await Request.post(
    '/mobile/reimbursements/process_receipt/',
    {
      downloadUrl,
      contentType,
    }
  )
  return response
}

export const confirmReceiptDetails = async (
  downloadUrl: string,
  receipts: {
    receiptId: string
    merchant: string
    amount: number
    receiptDate: string
    expenseType: string
    merchantCategory: string
    merchantCurrency: string
    merchantAmount: number
    employeeNote?: string | null
    manualReview: boolean
  }[]
) => {
  const payload = {
    download_url: downloadUrl,
    receipts: receipts.map((r) => ({
      receipt_id: r.receiptId,
      merchant: r.merchant,
      amount: r.amount,
      receipt_date: r.receiptDate,
      expense_type: r.expenseType,
      merchant_category: r.merchantCategory,
      merchant_currency: r.merchantCurrency,
      merchant_amount: r.merchantAmount,
      employee_note: r.employeeNote,
      manual_review: r.manualReview,
    })),
  }
  return Request.post(
    '/mobile/reimbursements/receipt_details/confirm/',
    payload
  )
}
